module.exports = __webpack_public_path__ + "img/goldcard.c9ce08c3.png";